import React from "react";
import { Link } from "react-router-dom";

const lastUpdated = "March 6, 2026";

const pageStyle = {
  maxWidth: 900,
  margin: "0 auto",
  padding: "24px 16px 48px",
  color: "#0f172a",
  lineHeight: 1.6,
};

const cardStyle = {
  background: "#ffffff",
  border: "1px solid #e2e8f0",
  borderRadius: 12,
  padding: 24,
  boxShadow: "0 2px 10px rgba(15, 23, 42, 0.05)",
};

const headingStyle = {
  marginTop: 28,
  marginBottom: 8,
  fontSize: 22,
  lineHeight: 1.3,
};

export default function PrivacyPolicyPage() {
  return (
    <div style={pageStyle}>
      <article style={cardStyle}>
        <header>
          <h1 style={{ margin: "0 0 8px", fontSize: 34, lineHeight: 1.2 }}>Privacy Policy</h1>
          <p style={{ margin: 0, color: "#475569" }}>
            <strong>App:</strong> CSB: Live Sports Analysis
            <br />
            <strong>Brand:</strong> Chartered Sports
            <br />
            <strong>Last updated:</strong> {lastUpdated}
          </p>
        </header>

        <section>
          <h2 style={headingStyle}>1. Who we are</h2>
          <p>
            Chartered Sports operates the CSB: Live Sports Analysis app and related website services. This policy
            explains what personal data we collect, how we use it, and your choices.
          </p>
        </section>

        <section>
          <h2 style={headingStyle}>2. Data we collect</h2>
          <ul>
            <li>
              <strong>Account data:</strong> email address, username, display name, and avatar/profile image.
            </li>
            <li>
              <strong>Date of birth:</strong> used for age gating and feature eligibility.
            </li>
            <li>
              <strong>Subscription metadata:</strong> entitlement status and transaction metadata from Apple In-App
              Purchases (we do not receive full payment card details).
            </li>
            <li>
              <strong>Usage and diagnostics:</strong> app activity, reliability logs, crash/performance diagnostics,
              and analytics where enabled.
            </li>
            <li>
              <strong>User content:</strong> comments, picks, chat messages, follows/favorites, and bet tracker
              entries.
            </li>
            <li>
              <strong>Device and push data:</strong> device/app identifiers, push token, and notification preferences.
            </li>
          </ul>
        </section>

        <section>
          <h2 style={headingStyle}>3. How we use data</h2>
          <ul>
            <li>To provide core app and website functionality.</li>
            <li>To apply age-restricted content controls.</li>
            <li>To verify subscription entitlements and purchases.</li>
            <li>To deliver notifications and protect account security.</li>
            <li>To monitor, improve, and support service reliability/performance.</li>
          </ul>
        </section>

        <section>
          <h2 style={headingStyle}>4. Legal basis and your rights</h2>
          <p>
            Where GDPR/UK GDPR applies, we rely on legal bases such as contract performance, legitimate interests,
            legal obligations, and consent (where required).
          </p>
          <p>You may have rights to:</p>
          <ul>
            <li>Access personal data we hold about you.</li>
            <li>Correct inaccurate or incomplete data.</li>
            <li>Request deletion of your data.</li>
            <li>Object to or restrict certain processing.</li>
            <li>Request data portability where applicable.</li>
          </ul>
          <p>
            Where CCPA/US state privacy laws apply, you may have rights to know, access, correct, and delete personal
            information, and to opt out of certain sharing uses where applicable.
          </p>
        </section>

        <section>
          <h2 style={headingStyle}>5. Sharing with third parties</h2>
          <p>We use service providers (processors) to operate the service, including:</p>
          <ul>
            <li>Firebase (authentication, messaging/storage as applicable)</li>
            <li>Apple (in-app purchase processing)</li>
            <li>Hosting and infrastructure providers</li>
          </ul>
          <p>
            We do <strong>not</strong> sell personal data.
          </p>
        </section>

        <section>
          <h2 style={headingStyle}>6. Data retention</h2>
          <p>
            We keep personal data only as long as needed for service operation, security, dispute resolution, and legal
            obligations.
          </p>
          <p>
            When you request account deletion, we delete or anonymize personal data unless retention is required by law
            or for legitimate security/compliance reasons.
          </p>
        </section>

        <section>
          <h2 style={headingStyle}>7. Children’s privacy and age restrictions</h2>
          <p>
            CSB is intended for users aged 18+. Under-18 users may have restricted access to betting/odds-related
            features.
          </p>
        </section>

        <section>
          <h2 style={headingStyle}>8. Security</h2>
          <p>
            We use industry-standard safeguards, including encryption in transit (TLS), access controls, and
            operational monitoring designed to protect personal data.
          </p>
        </section>

        <section>
          <h2 style={headingStyle}>9. International data transfers</h2>
          <p>
            Your data may be processed in countries outside your own. Where required, we apply appropriate safeguards
            for international transfers.
          </p>
        </section>

        <section>
          <h2 style={headingStyle}>10. How to request account/data deletion</h2>
          <ol>
            <li>Email your request to support@YOURDOMAIN from the account email, or include account identifiers.</li>
            <li>Use subject line: “Account Deletion Request”.</li>
            <li>
              We may ask for limited verification to protect your account from unauthorized deletion requests.
            </li>
            <li>We will confirm completion or explain any required retention exceptions.</li>
          </ol>
        </section>

        <section>
          <h2 style={headingStyle}>11. Contact us</h2>
          <p>
            <strong>Email:</strong> support@YOURDOMAIN
            <br />
            <strong>Address:</strong> YOUR COMPANY ADDRESS
          </p>
        </section>

        <section>
          <h2 style={headingStyle}>12. Policy changes</h2>
          <p>
            We may update this Privacy Policy from time to time. If we make material changes, we will update the “Last
            updated” date above and, where appropriate, provide additional notice.
          </p>
        </section>

        <footer style={{ marginTop: 32, paddingTop: 16, borderTop: "1px solid #e2e8f0" }}>
          <Link to="/" style={{ color: "#166534", fontWeight: 600, textDecoration: "none" }}>
            ← Back to home
          </Link>
        </footer>
      </article>
    </div>
  );
}
